import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import WOW from 'wowjs';

import Header from '../components/Header';
import Footer from '../components/Footer';

const MainLayout = () => {
  const { i18n } = useTranslation();

  // Initialize WOW.js and handle RTL direction
  useEffect(() => {
    new WOW.WOW({ live: false }).init();
    document.documentElement.dir = i18n.dir();
  }, [i18n, i18n.language]);

  return (
    <div className="App">
      <Header />
      <main>
        <Outlet /> {/* This will render the active page component (e.g., HomePage or AboutPage) */}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;